import React from 'react';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
// icons
import CaratRight from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/utility/CaratRight';
// native components
import LeadersTwoColumnContent from '../leadersTwoColumnContent';
// images
import profilePicWebp from './images/chro-kelly-culler.webp';
// styles
import {
  LinkedinStyledSocialIcon,
  LinkStyledBio,
} from '../../styles';

export default () => {
  const name = 'Kelly Culler';
  const nameString = 'kelly-culler';
  const title = 'Chief People Officer';

  return (
    <LeadersTwoColumnContent
      id='leaders-chief-people-officer'
      header={name}
      title={title}
      isExecutiveVicePresident
      content={(
        <>
          <Typography
            itemprop='description'
            nextElement='link'>
            Kelly oversees all aspects related to attracting, developing, and retaining talent for Northwestern Mutual&#39;s more than 8,300 employees, including the end&#45;to&#45;end campus and employee digital experience. She is passionate about shaping a vibrant, inclusive, and future&#45;ready workforce that drives measurable business outcomes.
          </Typography>
          <LinkStyledBio
            id={`leaders-section-${nameString}-bio-pdf-link`}
            linkUrl='/assets/pdf/leaders/culler-kelly-bio.pdf'
            ariaLabel={`Download the bio pdf for ${name}`}
            isInternalPdf
            endAdornment={CaratRight}
            endAdornmentStylesReset
            variant='buttonLinkTertiary'>
            See full bio
          </LinkStyledBio>
          <Row>
            <Col nested>
              <Link
                id={`leaders-section-${nameString}-linkedin-social-link`}
                variant='primary'
                linkUrl='https://www.linkedin.com/in/kellyiculler/'
                ariaLabel={`${name} Linkedin profile`}
                isOutgoingLink>
                <LinkedinStyledSocialIcon />
              </Link>
            </Col>
          </Row>
        </>
      )}
      image={profilePicWebp}
      imageAlt={`Northwestern Mutual Executive Vice President and ${title} ${name}.`}
      reversed={false}
    />
  );
};
